import { render, staticRenderFns } from "./gatewayacceptors.vue?vue&type=template&id=6e5ecb6e"
import script from "./gatewayacceptors.vue?vue&type=script&lang=js"
export * from "./gatewayacceptors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports